import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ContactUs } from 'src/app/model/page/contact-us';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-contact-us-page',
  templateUrl: './contact-us-page.component.html',
  styleUrls: ['./contact-us-page.component.scss']
})
export class ContactUsPageComponent implements OnInit {
  contactUs: ContactUs = {} as ContactUs;

  constructor(private contentfulService: ContentfulService) {}
  ngOnInit() {
    htmlTitle.filter((title) => {
      if (title.page === 'contact-us') {
        this.contactUs.htmlTitle = title.htmlTitle;
      }
    });
    this.contactUs.sections = [];
    this.contactUs.outageBanners = [];
    const menuQuery = { 'fields.name': 'LocationCountryDetails' };
    this.contentfulService.getMenuContentWithItems(menuQuery).then((menuItems) => {
      this.contactUs.cityCountryLists = menuItems[0]?.fields.jsonData;
    });

    const query = { 'fields.title': 'Contact-US' };
    this.contentfulService.getPageContentResponse(query).then((contactUsPageEntries) => {
      this.mapBanners(contactUsPageEntries.includes.Entry);
      this.mapOutageBanners(contactUsPageEntries.includes.Entry);
      this.mapAssets(contactUsPageEntries.includes.Asset);
      this.mapSections(contactUsPageEntries.includes.Entry);
      this.mapHtmlTitle(contactUsPageEntries.items);
    });
  }

  private mapBanners(contactUsPageBannerEntries: Entry<any>[]) {
    contactUsPageBannerEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'];
    this.contactUs.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }

  private mapOutageBanners(contactUsPageEntries: Entry<any>[]) {
    contactUsPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToOutageBanner(entry);
      });
  }

  private mapEntryToOutageBanner(entry: Entry<any>) {
    this.contactUs.outageBanners.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: '',
      iconClass: entry.fields['iconClass'] as string
    });
    this.contactUs.outageBanners.sort((a, b) => a.order - b.order);
  }

  private mapSections(contactUsPageSectionEntries: Entry<any>[]) {
    contactUsPageSectionEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.contactUs.sections.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
    this.contactUs.sections.sort((a, b) => a.group.localeCompare(b.group));
  }

  updateSelectedValue(selectedEvent: any) {
    this.contactUs.defaultSelectedCountry = selectedEvent.target.value;
    this.contactUs.sections.filter((section) => {
      if (section.group === this.contactUs.defaultSelectedCountry) {
        this.contactUs.defaultSelectedBody = section.body;
      }
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.contactUs.htmlTitle = entry.fields.htmlTitle;
      this.contactUs.belowBody = entry.fields.summary;
      this.contactUs.defaultSelectedCountry = entry.fields.constants.defaultCountryName;
      this.contactUs.contactUsTitle = entry.fields.constants.contactUsTitle;
      this.contactUs.sections.filter((section) => {
        if (section.group === this.contactUs.defaultSelectedCountry) {
          this.contactUs.defaultSelectedBody = section.body;
        }
      });
    });
  }

  getCountryName() {
    let countryList: any = this.contactUs.cityCountryLists;
    let currentTimeZone: any = Intl.DateTimeFormat().resolvedOptions().timeZone;
    currentTimeZone = currentTimeZone.split('/')[1];
    let country: any = '';
    if (countryList && typeof country !== 'undefined') {
      country = countryList[currentTimeZone];
    } else {
      country = 'United Kingdom';
    }
    return country;
  }

  mapAssets(assets: Entry<any>[]) {
    assets.filter((asset) => {
      if (asset.fields['title'] === 'Contact-Us-Card') {
        let file: any = asset.fields['file'];
        this.contactUs.cardImage = file.url;
      }
    });
  }
}
